import React, {Component} from 'react';
import {Session, DebitNotesDetailsModal} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

const apiClient = ApiClient.getInstance();

require('datatables.net-bs4');

class statusAccountView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            order: {
                header: {},
                body: []
            },
            Fconta : false,
            Reconciled : true,
        };
        this.table = null;
    }

    componentDidMount() {
        this.fillDataStatusAccount();
    }

    fillDataStatusAccount = () => {
        const {enableSpinner,data} = this.props;
        this.table = $('#tablaStatusAccount').DataTable({
            "paging": true,
            "info": false,
            "searching": false,
            "order": [[ 2, 'desc' ]],
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "No se encontraron registros",
                "info": "Mostrando página _PAGE_ de _PAGES_",
                "infoEmpty": "No existen registros",
                "infoFiltered": "(filtrado de _MAX_ entradas)",
                "loadingRecords": "Buscando...",
                "processing": "Procesando...",
                "search": "Buscar:",
                "paginate": {
                    "first": "Primero",
                    "last": "Último",
                    "next": "Siguiente",
                    "previous": "Anterior"
                }
            }
        });
    }

    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        if (this.props.orders != nextProps.orders) {
            this.table.destroy();
            this.table = null;
        }
        return true;
    }

    componentDidUpdate(): void {
        if (this.table == null) {
            this.fillDataStatusAccount();
        }
    }

    docChangeName(status) {
        let result = '';
        switch (status) {
            case 'YC':
                result = "ANULADO";
                break;
            case 'NO':
                result = "PENDIENTE";
                break;
            case 'NC':
                result = "CERRADO/PROCESADO";
                break;
            case 'N':
                result = "ABIERTO";
                break;
            default:
                break;
        }
        return result;
    };

    changeSunat(number) {
        let result = '';
        switch (number) {
            case -1:
                result = "En Proceso";
                break;
            case 0:
                result = "En Espera (Conector Local)";
                break;
            case 1:
                result = "En Espera (Nube Docele)";
                break;
            case 2:
                result = "Rechazado";
                break;
            case 3:
                result = "Aceptado con Observaciones";
                break;
            case 4:
                result = "Aceptado";
                break;
            default:
                result = " ";
                break;
        }
        return result;
    };

    openOrder = async docEntry => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        enableSpinner(true);
        let response = await apiClient.getDatagetStatusAccount(docEntry);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
            });

            $('#debitNotesModal').modal('show');
            return;
        }

        showAlert({type: 'error', message: "Aviso: "+response.message})
    };
    
    Transtype = view => {
        let name = "";
        switch (view) {
            case '13':
                name = "RF-Factura Deudores";
                break;
            case '14':
                name = "RC-Nota Credito Clientes";
                break;
            case '15':
                name = "NE-Entrega";
                break;
            case '16':
                name = "DV-Devolucion";
                break;
            case '18':
                name = "TT-Factura Proveedores";
                break;
            case '19':
                name = "PC-Nota Credito Proveedores";
                break;
            case '20':
                name = "EP-Entrada Mercancias";
                break;
            case '21':
                name = "DM-Devolucion Mercancías";
                break;
            case '24':
                name = "PR-Pagos Recibidos";
                break;
            case '30':
                name = "AS-Asiento";
                break;
            case '46':
                name = "PP-Pagos Efectuados";
                break;
            case '59':
                name = "EM-Entrada Mercancías";
                break;
            case '60':
                name = "OA-Emisión para producción";
                break;
            case '67':
                name = "IM-Transferencia de Stock";
                break;
            case '69':
                name = "DI-Precio Entrega";
                break;
            case '162':
                name = "RI-Revalorización Inventario";
                break;
            case '202':
                name = "OF-Orden de Fabricación";
                break;
            case '204':
                name = "AN-F Anticipo Proveedores";
                break;
            case '321':
                name = "ID-Reconciliación Interna";
                break;
        }

        return name;
    };

    handleChange = (event,index)=>{
        const {orders,openAccountBalance} = this.props;
        const {Fconta,Reconciled} = this.state;
        let data = orders;
        // let change = event.nativeEvent.target.value;
        data.DocDate = Fconta;
        data.OnlyUnreconciled = Reconciled;
        if(index === 1){
            data.DocDate = !Fconta;
            this.setState({
                Fconta: !Fconta,
            });
        }else if(index === 4){
            data.OnlyUnreconciled = !Reconciled;
            this.setState({
                Reconciled: !Reconciled,
            });
        }
        
        setTimeout(async  () => {
            await openAccountBalance(data);
        },200);
    }

    render() {
        const {order} = this.state;
        const { orders,header,getData,handleInputDateInicio, handleInputDateFinal, fechaFinal,fechaInicio, openAccountBalance}  = this.props;
        const {Fconta,Reconciled} = this.state;
        let Balance = 0;
        let DNotesBal = 0;
        let OrdersBal = 0;
        if(header){   
            Balance = Number(header.Balance);
            DNotesBal = Number(header.DNotesBal);
            OrdersBal = Number(header.OrdersBal);
        }
        return (
            <div className="content-fluid">
                <DebitNotesDetailsModal order={order}/>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className="col-md-12">
                        <h3>Estado de cuenta</h3>
                    </div>
                    </div>
                    <div className="row" style={{ paddingRight: 0 }}>
                    {/*Primer columna*/}
                    <div className="col-sm col">
                        {/*CardCode*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Código SN
                            </span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            id="txtPartner"
                            disabled={true}
                            value={header.CardCode || ""}
                        />
                        </div>
                        {/*Nombre*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Nombre
                            </span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            id="txtPartner"
                            disabled={true}
                            value={header.CardName || ""}
                        />
                        </div>
                        {/*Saldo de cuenta*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Saldo de cuenta
                            </span>
                        </div>
                        <CurrencyFormat
                            class="form-control"
                            disabled={true}
                            value={Balance || 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            prefix={config.general.currency}
                        ></CurrencyFormat>
                        </div>
                        {/*Entregas*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Entregas
                            </span>
                        </div>
                        <CurrencyFormat
                            class="form-control"
                            disabled={true}
                            value={DNotesBal || 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            prefix={config.general.currency}
                        ></CurrencyFormat>
                        </div>
                        {/*Pedidos*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Pedidos
                            </span>
                        </div>
                        <CurrencyFormat
                            class="form-control"
                            disabled={true}
                            value={OrdersBal || 0}
                            displayType={"text"}
                            thousandSeparator={true}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            prefix={config.general.currency}
                        ></CurrencyFormat>
                        </div>
                    </div>

                    {/*Segunda columna*/}
                    <div className="col-sm col">
                        {/*Fecha de contabilización:*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                            <input
                                type="checkbox"
                                id="Fconta"
                                aria-label="Checkbox for following text input"
                                checked={Fconta}
                                onChange={(event) => this.handleChange(event, 1)}
                            />
                            &nbsp;
                            <span class="font-weight-bold" id="basic-addon1">
                                {" "}
                                F. Contabilización
                            </span>
                            </div>
                        </div>
                        </div>
                        {/*DESDE*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Desde
                            </span>
                        </div>
                        <input
                            id="fechaInicio"
                            style={{
                            important: true,
                            backgroundColor: "transparent",
                            borderColor: "#ced4da",
                            color: "#000",
                            }}
                            type="date"
                            className="form-control"
                            name="fechauno"
                            value={fechaInicio}
                            onChange={(event) => handleInputDateInicio(event)}
                            onBlur={(event) => this.handleChange(event, 2)}
                        />
                        </div>
                        {/*Fecha de contabilización:*/}
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span
                            class="input-group-text font-weight-bold"
                            id="basic-addon1"
                            >
                            Hasta
                            </span>
                        </div>
                        <input
                            id="FechaFin"
                            style={{
                            important: true,
                            backgroundColor: "transparent",
                            borderColor: "#ced4da",
                            color: "#000",
                            }}
                            className="form-control"
                            type="date"
                            autoComplete="off"
                            value={fechaFinal}
                            onChange={(event) => handleInputDateFinal(event)}
                            onBlur={(event) => this.handleChange(event, 2)}
                        />
                        </div>
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                            <input
                                type="checkbox"
                                id="Reconciled"
                                aria-label="Checkbox for following text input"
                                checked={Reconciled}
                                onChange={(event) => this.handleChange(event, 4)}
                            />
                            &nbsp;
                            <span class="font-weight-bold" id="basic-addon1">
                                {" "}
                                Visualizar sólo operaciones no reconciliadas
                            </span>
                            </div>
                        </div>
                        </div>
                        <div class="input-group mb-3">
                        <button
                            onClick={() => openAccountBalance()}
                            className="btn botonResumen"
                            style={{
                            backgroundColor:
                                config.navBar.menuCategoriesBackgroundHover,
                            color: config.navBar.textColorCategorieHover,
                            fontWeight: "bold",
                            }}
                        >
                            Ver resumen
                        </button>
                        <div className="col-md-8 table-responsive text-right">
                            <label className="font-weight-bold">
                            Total:
                            <CurrencyFormat
                                value={orders.length > 0 ? orders[0].Saldo : 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                prefix={config.general.currency}
                            ></CurrencyFormat>
                            </label>
                        </div>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-12 table-responsive">
                        <table id="tablaStatusAccount" class="table table-striped">
                            <thead>
                                <tr style={{backgroundColor: config.shoppingList.summaryList, color: "white"}}>
                                    <th scope="col">F. contabilización</th>
                                    <th scope="col">F. vencimiento</th>
                                    <th scope="col">Días de atraso</th>
                                    <th scope="col">N°. trans.</th>
                                    <th scope="col">Origen</th>
                                    <th scope="col">N°. de origen</th>
                                    <th scope="col">Referencia 2</th>
                                    <th scope="col">Cuenta de contrapartida</th>
                                    <th scope="col">Info. detallada</th>
                                    <th scope="col">Total documento</th>
                                    <th scope="col">Saldo pendiente</th>
                                    {/* <th scope="col">Cargo (ML)</th>
                                    <th scope="col">Abono (ML)</th> */}
                                    {/* <th scope="col"></th> */}
                                </tr>
                            </thead>
                        <tbody>
                    {orders.map((order, index) => {
                      return (
                        <tr key={index} style={{color: order.TransType === "14" || order.TransType === "24" ? "green" : "black",}}
                        >
                          <td>{moment(order.RefDate).format("DD-MM-YYYY")}</td>
                          <td>{moment(order.DueDate).format("DD-MM-YYYY")}</td>
                          <td>{order.Atraso > 0 ? order.Atraso : ""}</td>
                          <td>{order.TransId}</td>
                          <td>{this.Transtype(order.TransType)}</td>
                          <td>{order.BaseRef}</td>
                          <td>{order.Ref2}</td>
                          <td>{order.ContraAct}</td>
                          <td>{order.LineMemo}</td>
                          <td className="text-right">
                            <CurrencyFormat
                              value={ order.Debit > 0 ? order.Debit : order.Credit > 0? order.Credit : 0 }
                              displayType={"text"}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                              decimalScale={2}
                              prefix={config.general.currency}
                            ></CurrencyFormat>
                          </td>
                          <td className="text-right">
                            <CurrencyFormat
                              value={ order.BalDueDeb > 0 ? order.BalDueDeb : order.BalDueCred > 0 ? order.BalDueCred : 0 }
                              displayType={"text"}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                              decimalScale={2}
                              prefix={config.general.currency}
                            ></CurrencyFormat>
                          </td>
                          {/* <td className="text-right">
                            {order.BalDueDeb > 0 ? (
                              <CurrencyFormat
                                value={order.BalDueDeb || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                prefix={config.general.currency}
                              ></CurrencyFormat>
                            ) : (
                              ""
                            )}
                          </td>
                          <td className="text-right">
                            {order.BalDueCred > 0 ? (
                              <CurrencyFormat
                                value={order.BalDueCred || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                prefix={config.general.currency}
                              ></CurrencyFormat>
                            ) : (
                              ""
                            )}
                          </td> */}
                          {/* <td>
                                            <sapn onClick={() => this.openOrder(order.DocEntry)}>
                                                <i className={config.icons.detail} style={{color: config.shoppingList.summaryList, paddingRight: 6}}></i>
                                                Detalle
                                            </sapn>
                                        </td> */}
                        </tr>
                      );
                    })}
                                    {/* <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className="text-right font-weight-bold">Total:</td>
                                        <td className="text-right font-weight-bold">
                                            <CurrencyFormat 
                                                value={Balance || 0} 
                                                displayType={'text'} 
                                                thousandSeparator={true} 
                                                fixedDecimalScale={true} 
                                                decimalScale={2} 
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td>
                                        <td></td>
                                        <td></td>                                    
                                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(statusAccountView);